<template>
  <v-navigation-drawer v-bind="$attrs">
    <template v-slot:prepend>
      <div>
        <v-toolbar flat dense>
          <v-toolbar-title class="subtitle-1">Section builder</v-toolbar-title>

          <v-spacer></v-spacer>
        </v-toolbar>

        <v-divider></v-divider>

        <v-toolbar flat dense v-if="tabs.length">
          <v-tabs v-model="currentTab" color="secondary">
            <v-tab v-for="tab in tabs" :key="tab" small>{{ tab }}</v-tab>
          </v-tabs>
        </v-toolbar>

        <v-divider v-if="tabs.length"></v-divider>
      </div>
    </template>

    <v-card
      flat
      tile
      :loading="$apollo.loading || drawer.loading"
      :disabled="$apollo.loading || drawer.loading"
      style="height:100%"
    >
      <v-card-text style="height:100%">
        <section-builder-presets
          :tabs.sync="tabs"
          :currentTab="currentTab"
        ></section-builder-presets>
      </v-card-text>
    </v-card>

    <template v-slot:append>
      <v-divider></v-divider>

      <v-toolbar flat dense>
        <span v-if="pageBySlug"
          >Drag and drop or double click to add sections to "{{
            pageBySlug.name
          }}" page.</span
        >
        <v-spacer></v-spacer>
        <v-btn
          text
          color="error"
          :disabled="drawer.loading"
          @click="closeEditor()"
          >Close</v-btn
        >
      </v-toolbar>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { activeTemplate } from '@/graphql/template.gql'
import { pageBySlug } from '@/graphql/page.gql'
import { mapState, mapActions } from 'vuex'
import SectionBuilderPresets from './SectionBuilderPresets'

export default {
  name: 'SectionBuilder',
  data: () => ({
    currentTab: null,
    tabs: []
  }),
  components: {
    SectionBuilderPresets
  },
  computed: {
    ...mapState('editor', ['drawer']),
    slug() {
      return (
        this.$route.params.page ||
        (this.activeTemplate
          ? this.activeTemplate.pages.filter(page => page.home)[0].slug
          : '')
      )
    }
  },
  apollo: {
    activeTemplate: {
      query: activeTemplate
    },
    pageBySlug: {
      query: pageBySlug,
      skip() {
        return !this.activeTemplate
      },
      variables() {
        return {
          data: {
            slug: this.slug,
            template_id: this.activeTemplate.id
          }
        }
      }
    }
  },
  methods: {
    ...mapActions('editor', ['closeEditor'])
  }
}
</script>
